export default {
    login: {
        email: 'Email',
        password: 'Password',
        submit: 'Login',
    },
    appName: {
        ngo: 'MEDforNGOs',
        hospital: 'MEDforHOSPs',
    },
    product: {
        med: 'medicine',
        hygProd: 'health product',
    },
    scan: {
        here: 'Scan here',
        start: 'Scan',
        end: 'Stop scanning',
        type: 'Type',
        twelveDigitCode: {
            title: 'Scan the 12-digit vertical code',
            text: '12-digit vertical code',
        },
        dataMatrix: {
            intro: 'Scan the 2D Data matrix',
            gtinDecodedSuccessfully: '✔ GTIN {gtin} decoded successfully!',
            eofcodeAttachedToGtin: '✔ {medName} (EOF code: {eofcode}) was linked to GTIN: {gtin}',
            eofcodeAlreadyAttachedToGtin: '✔ {medName} (EOF code: {eofcode}) is already linked to GTIN: {gtin}',
        },
        flash: {
            text: 'Flash',
            on: 'on',
            off: 'off',
            notSupported: 'This device does not support a flashlight.',
            cannotBeUsed: 'The flashlight cannot be used.',
        },
        camera: {
            notSupported: 'Camera is not supported on this device or browser.',
            permissionDenied: 'Permission denied. Please allow camera access in your browser settings.',
            notFound: 'No camera found (or it is in use by another app).',
            notReadable: 'Camera is busy or not readable.',
            pageNotSecure: 'This page is not secure (HTTPS required) for camera access.',
            couldNotStart: 'Could not start camera: {error}',
        },
    },
    profile: {
        pageTitle: 'My Profile',
        profileSections: {
            infoData: {
                dataTitle: 'Contact information',
                descriptionTitle: 'Organization\'s operation description',
                processTitle: 'Edit Contact information',
                name: 'Organization\'s name',
                userEmail: 'Email',
                numberOfBeneficiaries: 'Number of beneficiaries (monthly)',
                supervisor: 'Contact person\'s name',
                phone: 'Phone',
                municipality: 'Municipality',
                regionalUnity: 'Regional unity',
                website: 'Website',
                address: 'Address',
                description: 'Description',
                succesfulSubmittion: 'Your contact information has been updated successfully.',
            },
            connectToApp: {
                title: 'App login',
                processTitle: 'Edit login passwords',
                password: 'Password',
                oldPassword: 'Current password',
                newPassword: 'New password',
                repeatNewPassword: 'Repeat new password',
                succesfulSubmittion: 'Your password has been updated successfully.',
            },
            openingΗours: {
                title: 'Opening hours',
                insertTitle: 'Please fill in your organization\'s opening hours.',
                processTitle: 'Edit opening hours',
                monday: 'Monday',
                tuesday: 'Tuesday',
                wednesday: 'Wednesday',
                thursday: 'Thursday',
                friday: 'Friday',
                saturday: 'Saturday',
                sunday: 'Sunday',
                succesfulSubmittion: 'Your opening hours have been updated successfully.',
            },
            officialData: {
                title: 'Official organization information',
                insertTitle: 'Please fill in your organization\'s official ingormation.',
                official_name: 'Official name',
                headquarters: 'Headquarters',
                legal_representative: 'Legal representative',
                afm: 'VAT number',
                doy: 'Tax office',
                cooperation_agreement: 'Cooperation agreement',
                succesfulSubmittion: 'Your official information has been updated successfully.',
            },
        },
    },
    storage: {
        pageTitle: 'My storage',
        headers: {
            name: 'NAME',
            substance: 'SUBSTANCE',
            category: 'CATEGORY',
            quantity: 'QUANTITY',
            toDonate: 'DONATE',
            state: 'STATE',
            dateUpdated: 'DATE UPDATED',
            expirationDate: 'DATE EXPIRED',
            deliveryDate: 'DELIVERY DATE',
            delete: 'DELETE',
            company: 'COMPANY',
            companyDonator: 'COMPANY-DONATOR',
            donator: 'DONATOR',
            availableQuantity: 'AVAILABLE QUANTITY',
            medName: 'MEDICINE NAME',
            hygProdName: 'HEALTH PRODUCT NAME',
            transportMethod: 'TRANSPORT METHOD',
            orderStatus: 'ORDER STATUS',
            beneficiary: 'BENEFICIARY',
        },
        headerProps: {
            sortByText: 'Sort by',
        },
        actions: {
            donate: {
                success: 'Donation status updated successfully.',
                donateOnToOff: 'The medicine is no longer available for donation.',
                donateOffToOn: 'The medicine is now available for donation.',
            },
        },
        conditions: {
            condSealed: {
                yes: 'Sealed',
                no: 'Not sealed',
            },
            condSterilized: {
                yes: 'Sterilized',
                no: 'Not sterlized',
            },
            condUsed: {
                yes: 'Used',
                no: 'Unused',
            },
        },
        meds: {
            pageTitle: 'Medicines',
            breadcrumbTitle: 'My storage (Medicines)',
            breadcrumbMobileTitle: 'Storage(M)',
            noDataAlert: '<p class="ml-4 mb-2">Here you will find all the medicines you add.</p><p class="ml-4 mb-0">Add your first medicine by clicking "Add med" and scan or type in the 12-digit number in the medicine box or find it from the list.</p>',
            firstAlert: 'Make sure that the declared quantity for "donate now" is the actual amount! A problem arises if someone orders something that you forgot to delete.',
            secondAlert: 'If the medicine box contains less than half the amount, set the amount in pills.',
            stored: 'You have stored',
            editDialogTitle: 'How many {measurementUnit} do you have?',
        },
        hygProds: {
            pageTitle: 'Health products',
            breadcrumbTitle: 'My storage (Health products)',
            breadcrumbMobileTitle: 'Storage(HP)',
            noDataAlert: '<p class="ml-4 mb-2">Here you will find all the health products you add.</p><p class="ml-4 mb-0">Add your first health product by clicking "Add health product" and search it in the relevant list.</p>',
            editDialogTitle: 'How many {quantityType} do you have?',
        },
        pendingDonations: {
            title: 'Pending donations',
            orderedQuantity: 'ORDERED QUANTITY',
            donationCycle: 'DONATION CYCLE',
        },
        add: {
            pageTitle: 'Add',
            addMeds: {
                pageTitle: 'Add medicines in my storage',
                breadcrumbMobileTitle: 'Add(M)',
                addBy2DDataMatrix: 'Add by scanning the 2D Data Matrix',
                addByBarcode: 'Add by scanning or typing the 12-digit vertical code from the authenticity strip',
                addByList: 'Add from the list of all medicines',
                success: 'The medicine {new_storage_item} was added successfully.',
            },
            addHygProds: {
                pageTitle: 'Add health products in my storage',
                breadcrumbMobileTitle: 'Add(HP)',
                suggest: 'Suggest a new health product.',
                notFoundHygProd: 'You don\'t find the health product you want?',
                clickHereToAddNewHealthProduct: 'Click here to add new health product.',
                new: {
                    name: 'Full product name as shown on the package',
                    category: 'Category and subcategory to which it belongs',
                    company: 'Company that distributes it',
                    description: 'Description',
                    descriptionNote: '*Please only provide information about the new product. Do not include expiration date, quantity, or other details. After we review your request, we will contact you to add the product you want to donate.',
                    price: 'Price',
                    cancel: 'Cancel',
                    send: 'SEND',
                },
                success: 'The product {new_item} has been registered. It will be checked by GIVMED and then it will be added to the list.',
            },
        },
    },
    needs: {
        pageTitle: 'My needs',
        meds: {
            pageTitle: 'Medicines',
            breadcrumbTitle: 'My needs (Medicines)',
            breadcrumbMobileTitle: 'Needs(M)',
            boxes: 'How many boxes do you need?',
            totalQuantity: '<span class="font-italic"> You have declared need in: <span class="font-weight-bold"> {totalQuantity} </span>Boxes</span>',
            noDataAlert: '<p class="ml-4 mb-2">All your medication needs will be listed here. </p><p class="ml-4 mb-0">Register your first need by clicking on the "New need" button and type in the trade name or substance of the medicine you are looking for.</p>',
        },
        hygProds: {
            pageTitle: 'Health products',
            breadcrumbTitle: 'My needs (Health products)',
            breadcrumbMobileTitle: 'Needs(HP)',
            declared: 'You have declared need in',
            noDataAlert: '<p class="ml-4 mb-2">All your health product needs will be listed here.</p><p class="ml-4 mb-0">Register your first need by clicking on the "New need" button and type in the trade name or category/subcategory of the health product you are looking for.</p>',
            editDialogTitle: 'How many {quantityType} do you need?',
        },
        addMeds: {
            pageTitle: 'Add medicines to my needs',
            addByName: '1) Add by a trade name',
            addBySubstance: '2) Add by substance',
            chosenSubstances: 'Selected substances: ',
            alert: 'Add your needs by substance. You will get more available medicines and we are more likely to be able to cover them.',
            descriptionNote: '*List the substances for each need separately!',
            success: 'The medicine {new_need_item} was successfully registered.',
            successSubstances: 'Medicine with substance(s): {new_need_item} was successfully registered.',
        },
        addHygProds: {
            pageTitle: 'Add health products to my needs',
            addByCategory: '2) Add by category/subcategory',
            success: 'Product {new_need_item} was successfully registered.',
        },
    },
    order: {
        pageTitle: 'Order',
        type: {
            med: 'Medicines',
            hygProd: 'Health products',
        },
        prods: {
            menuTitle: 'Availability',
            pageTitle: 'Available medicines and health products',
            order: 'I want it',
            matchedNeed: 'Declared need in boxes: {matchedNeedQuantity}',
            availableForOrder: 'Available for order',
        },
        basket: {
            pageTitle: 'Basket',
            emptyStateTitleBtn: 'Order',
            completed: 'Complete order',
            tooltip: 'Remove the refrigerated medicine if you want to use ACS transport via GIVMED.',
            noDataAlert: '<p class="ml-4 mb-2">Here will be listed all the medicines and health products of your basket.</p><p class="ml-4 mb-2">Complete your orders so they move to "Incoming Donations" → "In Progress".</p>',
        },
        successOrder: '{new_donator} has received your order! See its progress in "Incoming Donations".',
        completeOrder: 'Order completed',
        givenToAcs: 'The order was assigned to ACS',
        givenToAcsModalText: 'Are you sure you delivered the package to ACS;',
        downloadDonationForm: 'Download donation form',
        isMedMaintaintedInFridge: 'Free ACS transport via GIVMED is not permitted, due to the inclusion of refrigerated medicine.',
    },
    incoming: {
        pageTitle: 'Incoming donations',
        pendingOrders: {
            pageTitle: 'Pending',
            noDataAlert: '<p class="ml-4 mb-2">This is where the orders you have made, but have not yet received, will be listed.</p><p class="ml-4 mb-0">After you complete your first order during the order cycle, the donations you will receive from other organizations will appear here.</p>',
            completedOrder: 'I received',
            completeOrderModalText: 'Are you sure you received the products?',
        },
        historyOrders: {
            pageTitle: 'History',
            noDataAlert: '<p class="ml-4 mb-2"> The orders you have received will be displayed here.</p><p class="ml-4 mb-0">To move them from "In Progress" to your "History", you must click the "Received" button for each order you receive.</p>',
            orgsTab: 'DONATIONS FROM PUBLIC BENEFIT ORGANIZATIONS',
            pharmasTab: 'DONATIONS FROM PHARMACEUTICAL COMPANIES',
            showProds: 'Show products',
            hideProds: 'Hide products',
        },
    },
    outgoing: {
        pageTitle: 'Outgoing donations',
        pendingOrders: {
            pageTitle: 'Pending',
            noDataAlert: '<p class="ml-4 mb-2">Here will be listed the orders that you have accepted during the current order cycle, but have not yet been delivered to the beneficiaries.</p><p class="ml-4 mb-0">When the beneficiaries receive them and press the corresponding button in the software, the orders will transfer to your "History".</p>',
        },
        closeOrgPendingOrders: {
            pageTitle: 'For donation',
            immediatelyDonate: 'All medicines and health products from your storage that have been declared for IMMEDIATE donation will be given to the recipient organization of your choice.',
            notProdsForImmediatelyDonate: '<p class="ml-4 mb-2">Either there are no medicines and health products for IMMEDIATE donation in your storage, or they have been declared for IMMEDIATE donation to a partner and when received they will appear in your history.</p><p class="ml-4 mb-0">For more information, contact the GIVMED team.</p>',
            recievedOrg: 'Receiving organization',
            readyForDelivery: 'Ready for delivery',
            checkOrg: 'Confirm that the organization: {org_name} can accept the products you want to donate.',
            selectedOrg: 'Order confirmation is awaited from: {org_name}',
            phone: 'Contact phone: {org_phone}',
            supervisor: 'Supervisor: {org_supervisor}',
            supervisorMail: 'Contact email: {org_supervisor_mail}',

        },
        historyOrders: {
            pageTitle: 'History',
            noDataAlert: '<p class="ml-4 mb-2">Here you will see the orders that you have accepted and have been successfully delivered to the beneficiaries.</p><p class="ml-4 mb-0">To move them from "In Progress" to your "History", you will need to click the "Received" button.</p>',
        },
    },
    completedOrderDateRange: 'Order completion date range',
    settings: {
        title: 'Settings',
        chooseTheme: 'Customize your web-app experience with light or dark theme.',
        dark: 'Dark',
        light: 'Light',
        langs: {
            select: 'Select language',
        },
    },
    faq: {
        title: 'Faq',
    },
    logout: 'Logout',
    table: {
        loading: 'Loading...',
        noData: 'No results found',
    },
    quantityType: {
        BOX: 'Box | Boxes',
        BAG: 'Bag | Bags',
        PIECE: 'Piece (subunit of box) | Pieces (subunits of box)',
        OTHER: 'Other | Others',
        ML: 'ml',
        pieces: 'Piece | Pieces',
        subUnit: '(subunit of box) | (subunits of box)',
    },
    extraQuantityType: {
        BOX: 'boxes',
        BAG: 'bags',
        PIECE: 'pieces (subunits of box)',
        OTHER: 'others',
    },
    measurementUnit: {
        B: 'Box | Boxes',
        P: 'Pill | Pills',
    },
    extraΜeasurementUnit: {
        B: 'boxes',
        P: 'pills',
    },
    conFormType: {
        CAPSULES: 'Capsules',
        AMPULES: 'Ampules',
        TABLETS: 'Tablets',
        SYRUP: 'Syrup',
        CREAM: 'Cream',
        COL: 'Col',
        INHALER: 'Inhaler',
        GEL: 'Gel',
        INJECTION: 'Injection',
        SACH: 'Sach',
        NASAL_SPRAY: 'Nasal spray',
        OTHER: 'Other',
    },
    conUnitType: {
        ml: 'ml',
        mg: 'mg',
        g: 'g',
        mcg: 'mcg',
        percent: '%',
        Other: 'Other',
    },
    filters: {
        searchBy: {
            nameOrSubstance: 'Search by the medicine name or substance',
            nameOrSubCategory: 'Search by the health product name or subcategory',
            healthProduct: 'Search for a health product (enter 3 characters)',
        },
        kindOfProduct: {
            hygProds: 'Health products',
            meds: 'Medicines',
        },
    },
    actions: {
        edit: {
            profileData: 'Edit',
            tooltip: 'Click to edit',
            cancel: 'CANCEL',
            save: 'Save',
            saveDialog: 'SAVE',
            updateDialog: 'UPDATE',
            continue: 'Continue',
            success: 'Successful update',
            successEntry: 'Successful registration',
            manyResults: 'Available in different organizations or expiration dates',
            order: 'ORDER',
            clickToOrder: 'Clcik to order',
            getMore: 'Show more',
        },
        deleteModal: {
            text: {
                product: 'Are you sure you want to delete this product?',
                order: 'Are you sure you want to delete this order and <span class="font-weight-bold text-decoration-underline">all its products?</span>',
            },
            cancel: 'Cancel',
            no: 'NO',
            yes: 'YES',
            success: 'Deletion completed successfully.',
        },
    },
    transportMethods: {
        PICK_UP: 'I will pick it up myself',
        OWN_COURIER: 'Transport with courier charge of the recipient',
        GIVMED_ACS_COURIER: 'Free transport of ACS via GIVMED',
    },
    donationStatus: {
        BASKET: 'Basket',
        PREPARATION: 'Preparation',
        ON_THE_WAY: 'Delivered to ACS Courier',
        COMPLETED: 'Completed',
    },
    labels: {
        med: 'Medicine',
        hygProd: 'Health product',
        medsWithSameSubstance: 'In Greece, {meds_count_from_substances} medicines with this substance are available.',
        quantity: 'Quantity',
        dateCreated: 'Date created',
        updateDate: 'Date updated',
        isMaintainedInFridge: 'Medicine maintained in fridge.',
        expirationDate: 'Expiration date',
        quantityType: 'Type',
        conForm: 'Format',
        conUnit: 'Type',
        concentration: 'Concentration',
        donationState: 'Select current product use',
        condition: 'Condition',
        toDonate: 'Available for immediate donation',
        notToDonateNow: 'Save to my storage',
        used: 'Used',
        sterilized: 'Sterilized',
        sealed: 'Sealed',
        delete: 'Delete',
        deleteOrder: 'Delete order',
        cancel: 'Cancel',
        exit: 'Έξοδος',
        total: 'Total',
        addToStorage: 'ADD TO MY STORAGE',
        addToNeeds: 'ADD TO MY NEEDS',
        yes: 'Yes',
        no: 'No',
        unknown: 'Unknown',
        itemsPerPage: 'Rows per page',
        from: 'from',
        workingHoursFrom: 'From',
        workingHoursTo: 'To',
        public: 'Public',
        website: 'https://www.example.com/page',
        beneficiaryDocuments: 'Official documents required for the provision of medicines and health products',
        agreeWithTerms: 'I agree to the terms of cooperation.',
        agree: 'Agree',
        signature: 'Signature',
        terms: 'Terms of cooperation',
        time: 'Hours(ΧΧ):(Minutes)(ΧΧ)',
        newMed: 'New medicine',
        newHygProd: 'New health product',
        newNeed: 'New need',
        gtin: 'GTIN',
        barcode: 'Barcode',
        insertBarcode: 'Type here the 12-digit vertical code',
        selectTransportMethod: 'Select transport method',
        medNotFound: 'Can\'t find your medicine in the list?',
        medNotFoundNotification: 'Send us the name of the medicine you couldn\'t find at hello@givmed.org.',
        medBarcodeNotFound: 'Was your 12-digit code not recognized?',
        medBarcodeNotFoundNotification: 'Send us the 12-digit code that was not matched to a medicine at hello@givmed.org.',
        authenticityΒand: 'Don\'t you have the medicine box or the authenticity strip missing?',
        autoChoiceBasedOnNeeds: 'Automatic selection based on your recorded needs',
        municipalitiesToOrder: 'Select the munipalities you want to search',
        organizationsToOrder: 'Select the organization you want to order from',
        quantityOrder: 'Ordered quantity',
        chooseSubstances: 'Select one or more substances',
        productType: 'Product type shown in the table below:',
        freeTransports: 'Free transports available with ACS: {free_transports}',
        successAddToBasket: 'The product has been added to the basket.',
        orders: 'Orders: {total_orders}',
        donators: 'Select donator',
        beneficiaries: 'Select beneficiary',
        pharmas: 'Select pharmaceutical company',
        pendingDeliveries: 'For delivery: {total_quantity_to_donate}',
        timer: 'Minutes to complete the order',
        approximatePrice: 'Approximate value of products: {totalPrice}€',
        approximatePriceAtLeastOneWithoutPrice: 'Approximate value of products: {totalPrice}€ <p style="font-size:12px;">*The price of some products is not taken into account due to lack of data.</p>',
        approximateTotalPrice: '{totalHistoryPrice}€ the approximate total value of products from public benefit organizations and public health structures.',
        approximateTotalPriceAtLeastOneWithoutPrice: '{totalHistoryPrice}€ the approximate total value of products from public benefit organizations and public health structures. <p class="mb-0 text-caption"">*The price of some products is not taken into account due to lack of data.</p>',
        approximateTotalPriceByOrgs: '{totalHistoryPriceDonatedByOrgs}€ the approximate total value of products from public benefit organizations.',
        approximateTotalPriceByOrgsAtLeastOneWithoutPrice: '{totalHistoryPriceDonatedByOrgs}€ the approximate total value of products from public benefit organizations. <p class="mb-0 text-caption"">*The price of some products is not taken into account due to lack of data.</p>',
        approximateTotalPriceByOrgsHistoryOutgoing: '{totalHistoryPriceDonatedByOrgs}€ the approximate total value of products to public benefit organizations and public health structures.',
        approximateTotalPriceByOrgsAtLeastOneWithoutPriceHistoryOutgoing: '{totalHistoryPriceDonatedByOrgs}€ the approximate total value of products to public benefit organizations and public health structures. <p class="mb-0 text-caption"">*The price of some products is not taken into account due to lack of data.</p>',
        approximateTotalPriceByPharmas: '{totalHistoryPriceDonatedByPharmas}€ the approximate total value of products from pharmaceutical companies.',
        tooltipBasketTitle: 'My basket',
        scrollRight: 'Scroll to the right to see the entire table.',
        and: 'and',
        forReceipts: 'For pickups by a representative of your organization or at your own courier expense, 3 days must have passed or you must have confirmed with the donator in advance.',
        price: 'Product price: {price}€',
        beneficiary: 'beneficiary',
        donator: 'donator',
        orgNoMoreExists: 'This organization-{typeOfOrg} does not exist.',
        fileFormat: 'File format',
        addHygProdExpDate: 'If the health product has an expiration date, enter it here.',
        back: 'Back',
        dateFrom: 'From',
        dateTo: 'To',
    },
    notifications: {
        successUpdateProduct: 'Product updated successfully',
        successDeleteProduct: 'Product deleted successfully',
        successDeleteOrder: 'Order deleted successfully',
        scanningIsNotLoading: 'The optical character recognition (OCR) library failed to load. Please reload the page.',
        warningOrderTimer: 'Kind reminder, don\'t forget to complete your order.',
        deleteBasketOrder: 'The medicines you had in your basket have been deleted. They are available for order to all users. You can add them to your basket again, but this time complete the order within the time limit. Refresh the page and start again!',
    },
    download: {
        text: 'Download',
        tooltips: {
            basedOnFilters: 'The download will be based on the selected filters.',
            donations:'Download detailed donation content',
        },
    },
    placeholders: {
        expDataMed: 'mm-yyyy',
        expDataHygProd: 'dd-mm-yyyy',
    },
    rules: {
        emailValidation: 'Please enter valid email.',
        quantity: 'Invalid quantity',
        minLength: 'Enter at least {length} characters.',
        minLengthMedExpiredDate: 'Enter all {length} digits of the expiration-date (mm-yyyy)',
        minLengthHygProdExpiredDate: 'Enter all {length} digits of the expiration-date (dd-mm-yyyy).',
        maxLengthDescription: 'Enter up to {length} characters.',
        notEmptyField: 'This field cannot be empty.',
        passwordsNotMatch: 'Passwords do not match.',
        lengthNum: 'Enter exactly {length} digits.',
        orderQuantity: 'The order quantity exceeds the storage quantity. Storage available quantity {availableQuantity}.',
        updateOrderQuantity: 'The order quantity exceeds the storage quantity. You have to reduce the ordered quantity by {orderedQuantityDiff}.',
        quantityOverNumber: 'The order quantity must be greater than {digit}.',
        concentrationQuantityOverNumber: 'The concentration quantity must be greater than {digit}.',
        isExpired: 'The date is overdue.',
        isValid: 'The date is invalid.',
    },
    newAppVersionAvailable: {
        text: 'New version available. Download it now!',
        btn: 'Upgrade',
    },
    errorCodes: {
        serverConnectionProblem: 'No connection to server. Please contact us!',
        timeoutExceeded: 'Timeout exceeded. The request did not get a response in time.',
        generalValidationError: 'Wrong input.',
        availableQuantityNegative: 'You cannot reduce the quantity to this number because there is a pending donation.',
        deletionNotPermittedPendingDonation: 'Deletion is not allowed because there is a pending donation.',
        multipleObjectsReturned: 'Multiple objects returned',
        accountDisabled: 'User account has been disabled.',
        userAlreadyExists: 'User with this email already exists.',
        wrongCredentials: 'Email or password fields are incorrect',
        validationErrorException: 'An exception occurred',
        wrongCurrentPassword: 'Wrong current password',
        authenticationFailed: 'Authentication failed',
        coveredQuantity: 'Covered quantity greater than quantity in need.',
        sendEmailException: 'An error occurred while trying to send email to user',
        transactionIntegrityError: 'Transaction integrity error',
        isMedNarcotic: 'In the GIVMED network, donations of medicines administered with a special drug prescription are not allowed.',
        isMedExpired: 'Expired medicines are not allowed to be registered.',
        isHygProdExpired: 'Expired health products are not allowed to be registered.',
        eofMedInfoNotFoundFromGivenBarcode: 'The 12-digit code you entered was not recognized by the national medicines agency. Please try again! If you need help, contact us at hello@givmed.org',
        quantityZeroOrNegative: 'If you do not need {product} anymore, delete it!',
        failureUpdateProduct: 'Product renewal failed',
        failureDeleteProduct: 'Product deletion failed',
        orderedQuantityGreaterThanAvailableQuantity: 'The order quantity exceeds the available quantity. The available quantity is {value}.',
        orderedQuantityGreaterThanAvailableQuantityInExistingOrder: 'The order quantity exceeds the available quantity of the donator. You have to reduce the quantity by {value}.',
        newOrderQuantityGreaterThanOld: 'It is not allowed to increase the order quantity of the product. You can reduce the quantity or delete the product completely.',
        orderedMedsMaintainedInFridgeCannotBeTransportedViaACS: 'Technical problem due to medicine maintained in fridge. Contact the GIVMED team at hello@givmed.org, 210 3007 222.',
    },
};
